/** Session-scoped exec pricing overrides (CONF-106 part 2).
 *  DELIBERATELY NOT part of FlatConfig/DomainConfiguration serialization:
 *  part 2 is session-only; part 3 adds {catalogValue, overrideValue, actor, at}
 *  persistence and wires a box into the mapper. Costs are integer µ$. */
export interface PricingOverrides {
  componentCosts: Record<string, Record<string, number>>;  // productSku -> componentSku -> µ$
  integrationBp: number | null;                            // null = catalog value
}
export const emptyOverrides = (): PricingOverrides => ({ componentCosts: {}, integrationBp: null });
export const hasOverrides = (o: PricingOverrides): boolean =>
  o.integrationBp !== null || Object.keys(o.componentCosts).length > 0;
export const countChanges = (o: PricingOverrides): number =>
  (o.integrationBp !== null ? 1 : 0) +
  Object.values(o.componentCosts).reduce((n, m) => n + Object.keys(m).length, 0);
export const dollarsToMicros = (d: number): number => Math.round(d * 1e6);

export function withComponentCost(
  o: PricingOverrides, productSku: string, componentSku: string, costMicros: number | null,
): PricingOverrides {
  const sku = { ...(o.componentCosts[productSku] || {}) };
  if (costMicros === null) delete sku[componentSku]; else sku[componentSku] = costMicros;
  const componentCosts = { ...o.componentCosts };
  if (Object.keys(sku).length === 0) delete componentCosts[productSku];
  else componentCosts[productSku] = sku;
  return { ...o, componentCosts };
}
export const withIntegrationBp = (o: PricingOverrides, bp: number | null): PricingOverrides =>
  ({ ...o, integrationBp: bp });
export function clearSku(o: PricingOverrides, productSku: string): PricingOverrides {
  const componentCosts = { ...o.componentCosts };
  delete componentCosts[productSku];
  return { ...o, componentCosts };
}
